"use client";
import {
  UserGroupIcon,
  HomeIcon,
  DocumentDuplicateIcon,
  UserIcon,
  UsersIcon,
  QueueListIcon,
  EnvelopeIcon,
  CogIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";
import clsx from "clsx";
import { Link, useLocation } from "react-router-dom";
import { UserRole } from "../../enums";

// Map of links to display in the side navigation.
// Depending on the size of the application, this would be stored in a database.
const links = [
  { name: "Home", href: "/client", icon: HomeIcon ,
    roles: [UserRole.USER],
  },
  { name: "Home", href: "/admin", icon: HomeIcon ,
    roles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },
  {
    name: "Allergy",
    href: "/admin/allergy-categories",
    icon: QueueListIcon,
    roles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },
  {
    name: "Charity Issue",
    href: "/admin/charity-issue-categories",
    icon: QueueListIcon,
    roles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },
  {
    name: "Charities",
    href: "/admin/charities",
    icon: QueueListIcon,
    roles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },
  {
    name: "Event Occasions",
    href: "/admin/event-occasions",
    icon: QueueListIcon,
    roles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },
  {
    name: "Dietary Preferences",
    href: "/admin/dietary-preferences",
    icon: QueueListIcon,
    roles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },
  {
    name: "Temporary Illnesses",
    href: "/admin/temporary-illnesses",
    icon: QueueListIcon,
    roles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },
  {
    name: "Greeting Occasion",
    href: "/admin/greeting-occasion-categories",
    icon: QueueListIcon,
    roles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  }, 
  {
    name: "Greeting Occasion Images",
    href: "/admin/greeting-occasions-images",
    icon: QueueListIcon,
    roles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  }, 
  {
    name: "Physical & Mental Symptoms",
    href: "/admin/physical-and-mental-symptoms",
    icon: QueueListIcon,
    roles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  }, 
  // {
  //   name: "Templates",
  //   href: "/admin/email-templates",
  //   icon: EnvelopeIcon,
  //   roles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  // },
 
  // {
  //   name: "Contact Us",
  //   href: "/admin/contact-us",
  //   icon: PhoneIcon,
  //   roles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  // },
  {
    name: "Users",
    href: "/admin/users",
    icon: UsersIcon,
    roles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },  
  // {
  //   name: "Server Settings",
  //   href: "/admin/server-settings",
  //   icon: CogIcon,
  //   roles: [UserRole.SUPERADMIN],
  // },
  {
    name: "My Profile",
    href: "/admin/profile",
    icon: UserIcon,
    roles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },
    {
    name: "My Profile",
    href: "/client/profile",
    icon: UserIcon,
    roles: [UserRole.USER],
  },
];

export default function NavLinks({role=undefined}:{role?:UserRole}) {
  const location = useLocation();
  const pathName = location.pathname;
  if(!role)
    return null;
  return (
    <>
      {links.filter((link) => !link.roles || link.roles.includes(role)).map((link) => {
        const LinkIcon = link.icon;
        return (
          <Link
            key={link.name}
            to={link.href}
            className={clsx(
              "flex h-[48px] grow items-center justify-center gap-2 rounded-md bg-gray-50 p-3 text-sm font-medium hover:bg-purple-100 hover:text-purple-600 md:flex-none md:justify-start md:p-2 md:px-3",
              {
                "bg-purple-100 text-purple-600": link.href === pathName,
              }
            )}
          >
            <LinkIcon className="w-6" />
            <p className="hidden md:block">{link.name}</p>
          </Link>
        );
      })}
    </>
  );
}
